import { FormType } from "types/gql-types";

export const humanizeFormType = (name: FormType, plural = false): string => {
  let formTypeName = name as string;
  switch (name) {
    case FormType.AFFIDAVIT:
      formTypeName = "Affidavit";
      break;
    case FormType.FULL_APPLICATION:
      formTypeName = "Full Application";
      break;
    case FormType.INTEREST_LIST_SUBMISSION:
      formTypeName = "Interest List Submission";
      break;
    case FormType.PRE_APPLICATION:
      formTypeName = "Pre Application";
      break;
    case FormType.VERIFICATION:
      formTypeName = "Verification";
      break;
    default:
      formTypeName = name;
      break;
  }
  return plural ? `${formTypeName}s` : formTypeName;
};
